export default "__VITE_ASSET__DVNb_o$e__"